export default __webpack_public_path__ + "static/media/incomingothermessage.05b45e68.wav";